module.exports = __webpack_public_path__ + "static/media/4H.6369d1c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4H.svg
// module id = 63
// module chunks = 0